<template>
	<button class="button outline" type="button" @click.prevent="copyValue">
		<span v-if="copied">{{copiedText}}</span>
		<span v-else><slot/></span>
	</button>
</template>

<script>
export default {
	props : {
		toCopy : {
			type     : String,
			required : true
		},
		copiedText : {
			type    : String,
			default : 'Copied!'
		},
	},
	data () {
		return {
			copied : false,
		}
	},
	computed : {
		text () {
			return this.copied ? this.copiedText : this.toolTipText
		}

	},
	methods : {
		copyValue () {
			this.$copyText(this.toCopy)
				.then(() => (this.copied = true))
				.then(() => setTimeout(() => {
					setTimeout(() => {
						this.copied = false
					}, 0)
				}, 3000))
		}
	}
}
</script>

<style lang="scss">
.input-copy-group {
	display: flex;
	align-items: flex-start;
	input {
		margin-right: 10px;
		font-family: monospace !important;
		font-size: .9em !important;
		line-height: 14px;
		height: 37px;
	}
}
</style>
